import { AlertDecagramOutlineIcon } from './AlertDecagramOutlineIcon';

/**
 * author: Peter Noble
 * id B2984FA7-4B68-4191-8835-EB768C58DD10
 * name alert-decagram-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-decagram-outline.svg
 * tags
 * - Alert / Error 
 */
export const WarningDecagramOutlineIcon = AlertDecagramOutlineIcon;
export default WarningDecagramOutlineIcon